import { Editor } from '@tiptap/core';
import { useCreateComment } from './useCreateComment';
import { useUpdateComment } from './useUpdateComment';
import { useState } from 'react';
import { usePostCommunicationContext } from '../../PostCommunicationProvider';
import { CommentAnnotation } from 'app/modules/comments/types';

type UseUpsertCommentOptions = {
  getAnnotation?: () => CommentAnnotation | null;
};

export function useUpsertComment(options?: UseUpsertCommentOptions) {
  const { comment, commentAction } = usePostCommunicationContext();
  const [editorRef, setEditorRef] = useState<Editor | undefined>(undefined);

  const { onSubmit: onCreate, isLoading: isCreateLoading } = useCreateComment({
    editorRef,
    setEditorRef,
    getAnnotation: options?.getAnnotation,
  });
  const { onSubmit: onUpdate, isLoading: isUpdateLoading } = useUpdateComment({
    editorRef,
    setEditorRef,
  });

  const onSubmit = () => {
    if (commentAction === 'edit' && comment?.id) {
      onUpdate(comment?.id);
    } else {
      onCreate();
    }
  };

  return {
    editorRef,
    setEditorRef,
    onSubmit,
    isLoading: isCreateLoading || isUpdateLoading,
  };
}
